import { importTranslationsBackground } from "../../../shared/translation/initialisation";
import globalResources from "./common/en-GB.json";

importTranslationsBackground("translation", { "en-GB": globalResources });
